import { CssBaseline, Paper } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { ThemeType } from "types/createTheme";
import getTheme from "theme";
import React from "react";
import SnackBar from "./SnackBar";
import ContextProvider from "./ContextProvider";

export const useDarkMode = (): [string, ThemeType, (mode: ThemeType) => void, boolean] => {
	const [themeMode, setTheme] = React.useState<ThemeType>("system");
	const [mountedComponent, setMountedComponent] = React.useState(false);

	const setMode = (mode: ThemeType) => {
		try {
			window.localStorage.setItem("themeMode", mode);
		} catch {
			/* do nothing */
		}

		setTheme(mode);
	};

	const themeToggler = (mode: ThemeType): void => {
		setMode(mode);
		//themeMode === "light" ? setMode("dark") : setMode("light");
	};

	const theme = React.useMemo(() => {
		if (themeMode !== "system") return themeMode;
		return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
	}, [themeMode]);

	React.useEffect(() => {
		try {
			const localTheme = window.localStorage.getItem("themeMode") as ThemeType;
			localTheme ? setTheme(localTheme) : setMode("system");
		} catch {
			setMode("system");
		}

		setMountedComponent(true);
	}, []);

	return [theme, themeMode, themeToggler, mountedComponent];
};

const Page = ({ children }: { children: React.ReactNode }): JSX.Element => {
	const [theme, themeMode, themeToggler, mountedComponent] = useDarkMode();

	return (
		<ThemeProvider theme={getTheme(theme, themeToggler)}>
			{/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
			<CssBaseline />
			<Paper
				elevation={0}
				sx={{ height: 1, bgcolor: "alternate.main" }}>
				<SnackBar>
					<ContextProvider>{children}</ContextProvider>
				</SnackBar>
			</Paper>
		</ThemeProvider>
	);
};

export default Page;
